import React from 'react';
import type { CompanionArtworkProps } from './types';

/** A quiet source mark for Wise Friend's dynamic questions and responses. */
export const WiseFriendMark: React.FC<CompanionArtworkProps> = ({ mood }) => (
  <svg
    className={`wf-wise-friend-mark${mood === 'thinking' ? ' wf-wise-friend-mark--pending' : ''}`}
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="none"
    aria-hidden="true"
    focusable="false"
    data-testid="wise-friend-mark"
  >
    <path
      d="M12 3 C13.5 8.6 15.4 10.5 21 12 C15.4 13.5 13.5 15.4 12 21 C10.5 15.4 8.6 13.5 3 12 C8.6 10.5 10.5 8.6 12 3Z"
      fill="#FFF0EA"
      stroke="#A55B43"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </svg>
);
